// Entity-type -> PrimeIcon class, mirroring the navigation mappings
// (OmniBox.vue's `getIcon`). Shared by the reconcile queue items and the
// accept dialog's resolution summary.
const ENTITY_ICON_BY_TYPE: Record<string, string> = {
    organization: "pi pi-building",
    stek: "pi pi-sitemap",
    domain: "pi pi-cloud",
    product: "pi pi-box",
    role: "pi pi-id-card",
    business_entity: "pi pi-building",
    domain_term: "pi pi-book",
    process: "pi pi-share-alt",
    task: "pi pi-check-square",
    gateway: "pi pi-directions",
    event: "pi pi-stop-circle",
    flow: "pi pi-window-minimize",
    artefact: "pi pi-file",
    artefact_group: "pi pi-folder",
    document: "pi pi-file",
    application: "pi pi-server",
    application_entity: "pi pi-table",
};

export const entityIcon = (entityType: string | undefined): string =>
    ENTITY_ICON_BY_TYPE[entityType ?? ""] ?? "pi pi-circle";
